export const newsCardStyles = {
  main: {
    display: "flex",
    // flexWrap: "wrap",
    // justifyContent: "space-between",
    // alignItems: "center",
    cursor: "pointer",
  },
  description: {
    display: "flex",
    // flexWrap: "wrap",
    flexDirection: "column",
    padding: "8px",
  },
  blogImgBox: {
    width: "250px",
    height: "100px",
    marginRight: "16px",
  },
  blogImg: {
    // width: "100px",
    // height: "100px",
    // objectFit: "cover",
  },
  blogTitle: {
    fontWeight: 500,
    fontSize: "11px",
    lineHeight: "13px",
    textTransform: "uppercase",
    color: "#21B8F9",
    marginBottom: "8px",
  },
  blogDetails: {
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "20px",
    color: "#103B66",
    marginBottom: "8px",
  },
  blogTime: {
    fontWeight: 300,
    fontSize: "12px",
    lineHeight: "12px",
    textDecorationLine: "underline",
    color: "#103B66",
  },
};
